import { useState } from 'react';
import { TextField } from '../../../components/TextField/TextField';

const EmailOptOutField = () => {
    const [fieldValue, setFieldValue] = useState('');
    const [isValid, setIsValid] = useState<boolean | undefined>(undefined);
    const [touched, setTouched] = useState(false);
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setTouched(true);
        setFieldValue(e.target.value);
        validateForUI(e.target, 'optimistically');
    };

    const validateForUI = (input: HTMLInputElement, mode?: string) => {
        const isValid = input.checkValidity();
        if (mode === 'optimistically') {
            if (isValid) {
                return setIsValid(true);
            }
            return setIsValid(undefined);
        }

        setIsValid(input.checkValidity());
    };

    const getValidationStatusClassName = () => {
        if (isValid === undefined) {
            return undefined;
        }
        return isValid ? 'valid' : 'invalid';
    };

    return (
        <TextField
            label="Enter your email to opt out"
            name="customerEmail"
            onChange={handleChange}
            disabled={false}
            helperText={touched && !isValid ? 'Your email is required in order to opt out.' : undefined}
            maxLength={250}
            type="email"
            id="customerEmail-optOut"
            onBlur={(e) => validateForUI(e.target)}
            value={fieldValue}
            required={true}
            validationStatus={getValidationStatusClassName()}
        />
    );
};

export default EmailOptOutField;
